/* eslint-disable import/prefer-default-export */
// export const SERVER_ADDRESS = 'https://threepointzero.app/api'
export const SERVER_ADDRESS = process.env.REACT_APP_SERVER_URL
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY

console.log(process.env)
